import { IOptionAnyValue } from 'bricks/types';
import { ProFormaModelIds } from 'constants/proForma';
import { IExpense } from 'views/ProFormaWizard/BasicInformation/hooks/useExpenses';

export interface BasicInformationValues {
    landArea: number;
    buildings: number;
    builtGrossSquareFootage: number;
    stories: number;
    sellingCosts: number;
    projectedCapRateAtSale: number;
    currentMarketCapRate: number;
    parking: IOptionAnyValue[];
    structuredParkingSpaces: number;
    surfaceParkingSpaces: number;
    trailerParkingSpaces: number;
    isFAR: boolean;
    floorAreaRatio: number;
    grossBuildableArea: number;
    startDate: Date | null;
    saleDate: Date | null;
    landAreaUnit: string;
    grossBuildableUnit: string;
    calculateArea: boolean;
}

export interface DevelopmentValues {
    acquisitionCosts: number;
    hardCosts: number;
    totalHardCosts: number;
    softCosts: number;
    totalSoftCosts: number;
    interestReserve: number;
    developerFee: number;
    sources: any[];
    hardCostType: string;
    softCostType: string;
}

export interface OperationsValues {
    unitArray: any[];
    incomeArray: any[];
    operatingInfoValues: any;
    expensesValues: any;
    expensesDetail: IExpense[];
}

export interface ProFormaQuickStartValues {
    basicInformation: BasicInformationValues;
    development: DevelopmentValues;
    operations: OperationsValues;
}

export const AssetTypeToProFormaModelIdMap: Record<string, ProFormaModelIds> = {
    apartment: ProFormaModelIds.APARTMENT,
    industrial: ProFormaModelIds.INDUSTRIAL,
    retail: ProFormaModelIds.RETAIL,
    ofice: ProFormaModelIds.OFFICE,
    dataCenter: ProFormaModelIds.DATA_CENTER,
};
